import { createSelector } from 'reselect'

const getSlideId = (state, slide_uid) => slide_uid
const getStudentViewData = state => state.student

const slideDataSelector = createSelector(
	[ getStudentViewData, getSlideId ],
	(student, slideId) => {
		const slide_data = student.slides[slideId]

		return slide_data
	}
)

export default slideDataSelector
